<template>
<div class="content">

        <div class="info-page">
          <div class="sub-section">
            <div class="container">
              <div class="content-container">
                <div class="content-text text-size-middle">
                  <h1>
                    Условия доступа к интернет-ресурсу <br>
                    и условия пользования <br> интернет-ресурсом
                  </h1>
                  <h3>Уважаемые Пользователи данного интернет-ресурса</h3>
                  <p>Настоящие Условия доступа к интернет-ресурсу и условия пользования интернет-ресурсом являются для
                    Вас обязательными и подготовлены в соответствии с законодательством Республики Казахстан об
                    информатизации, об охране интеллектуальной собственности, о персональных данных и их защите,
                    законодательством в области здравоохранения и другими нормативными правовыми актами и
                    международными договорами.</p>
                  <h3>
                    1. Термины и определения
                  </h3>
                  <p>
                    Перечисленные ниже термины используются в настоящих Условиях в следующих значениях:
                  </p>
                  <p>
                    1.1. Группа компаний Тева – следующие лица, как вместе, так и каждое в отдельности: компания
                    Teva Pharmaceutical Industries Limited, её дочерние и взаимосвязанные организации и филиалы, а
                    также по её решению – другие юридические лица, входящие в группу компаний Тева, включая
                    Компанию.
                  </p>
                  <p>
                    1.2. Интеллектуальная Собственность – доменное имя; дизайн Сайта; коды, содержащиеся в
                    пользовательском интерфейсе и структуре данного Сайта; вся Информация, включая, в том числе,
                    изображения, объекты авторского права, объекты смежных прав, товарные знаки, фирменные
                    наименования, торговые наименования, логотипы, знаки обслуживания, изобретения, полезные модели,
                    промышленные образцы, патенты, торговые секреты; иные объекты интеллектуальной собственности,
                    представленные на Сайте; программное обеспечение Сайта.
                  </p>
                  <p>
                    1.3. Информация – содержимое Сайта, включая всю и любую информацию, размещённую на Сайте, в
                    любой форме
                    и в любом выражении (в том числе, графическом, текстовом, аудио и/или визуальном или ином),
                    подкасты, данные, содержащиеся в RSS и Atom- каналах (лентах) и файлах.
                  </p>
                  <p>
                    1.4. Компания – Товарищество с ограниченной ответственностью "ратиофарм Казахстан" (БИН 071 040
                    003 425).
                  </p>
                  <p>
                    1.5. Пользователь – любой посетитель Сайта, любое лицо, осуществляющее ознакомление с
                    Информацией, или претендующее на доступ к Сайту или Информации.
                  </p>
                  <p>
                    1.6. Разрешённое Использование – ознакомление в личных некоммерческих целях с Информацией,
                    находящейся
                    в открытом для данной категории Пользователей доступе на Сайте, при условии ненарушения
                    Пользователем установленных запретов и ограничений.
                  </p>
                  <p>
                    1.7. Сайт – настоящий интернет-ресурс.
                  </p>
                  <p>
                    1.8. Условия – настоящие Условия доступа к интернет-ресурсу и условия пользования
                    интернет-ресурсом.
                  </p>
                  <p>1.9. Разрешённое Использование – ознакомление в личных некоммерческих целях с Информацией,
                    находящейся
                    в открытом для данной категории Пользователей доступе на Сайте, при условии ненарушения
                    Пользователем установленных запретов и ограничений.</p>
                  <h3>
                    2. Принадлежность Сайта
                  </h3>
                  <p>
                    2.1. Сайт принадлежит Компании. Компания является собственником и администратором Сайта.
                  </p>
                  <p>
                    2.2. Компания обладает лицензией Республики Казахстан на фармацевтическую деятельность (подвид –
                    оптовая реализация лекарственных средств) № 17006405, выданной 13 апреля 2017 года Управлением
                    предпринимательства
                    и индустриально-инновационного развития города Алматы Акимата города Алматы (дата первичной
                    выдачи – 30 августа 2012 года).
                  </p>
                  <h3>3. Обязательность Условий</h3>
                  <p>3.1. Условия являются обязательными для всех Пользователей Сайта.</p>
                  <p>3.2. При первом и каждом последующем доступе к Сайту обязанностью Пользователя является
                    внимательное ознакомление с текущими Условиями.</p>
                  <p>3.3. Компания вправе в любое время пересмотреть и изменить Условия, обновив данную публикацию.
                    Такие обновления являются для Вас обязательными, и, поэтому, Вам следует посещать данную
                    страницу при каждом доступе к Сайту для ознакомления с действующими на текущий момент
                    Условиями.</p>
                  <h3>
                    4. Принятие Условий
                  </h3>
                  <p>
                    4.1. При доступе к Сайту и просмотре его Информации Вы принимаете настоящие Условия, без
                    каких-либо ограничений или оговорок.
                  </p>
                  <p>
                    4.2. Если Вы не согласны с настоящими Условиями, Вы обязаны не пользоваться Сайтом и покинуть
                    его.
                  </p>
                  <h3>
                    5. Права интеллектуальной собственности
                  </h3>
                  <p>
                    5.1. Сайт и Интеллектуальная Собственность являются объектом охраны авторского права и иного
                    права интеллектуальной собственности как в Республике Казахстан, так и за её пределами. Все
                    исключительные, имущественные и иные права на Сайт и Интеллектуальную Собственность принадлежат
                    Компании и/или иным правообладателям (в применимых случаях).
                  </p>
                  <p>
                    5.2. Вам следует принять к сведению, что всё, что Вы видите или можете прочесть на Сайте,
                    защищено и охраняется авторским правом, гражданским законодательством и иными законами
                    Республики Казахстан, иных стран и международными договорами и не может быть использовано без
                    письменного разрешения Компании или иного правообладателя (в применимых случаях).
                  </p>
                  <p>
                    5.3. Вся Интеллектуальная Собственность, включая наименования "Teva", "Тева", "ратиофарм",
                    "ratiopharm", "Актавис", "Actavis", представляют собой зарегистрированные и незарегистрированные
                    объекты права интеллектуальной собственности Компании либо компаний, входящих в Группу компаний
                    Тева или иных правообладателей (в применимых случаях).
                  </p>
                  <p>
                    5.4. Группа компаний Тева и Компания будут активно осуществлять свои права интеллектуальной
                    собственности по всей строгости закона, включая требования о возмещении убытков, взыскание
                    компенсаций, уголовное и административное преследование.
                  </p>
                  <p>
                    5.5. Ничто из Информации не должно толковаться как предоставление (подразумеваемым образом, в
                    силу правовой презумпции, или иным образом), какой-либо лицензии или права на использование
                    какой-либо Интеллектуальной Собственности без письменного разрешения Компании или иного
                    правообладателя, который может владеть Интеллектуальной Собственностью.
                  </p>
                  <p>
                    5.6. Изображения людей или мест, приведённые на Сайте, либо являются собственностью
                    Компании/иного правообладателя, либо используются Компанией/иным правообладателем с
                    соответствующего разрешения. Использование таких изображений Вами или кем-либо уполномоченным
                    Вами, запрещено. Любое незаконное использование изображений может привести к нарушению прав
                    владельцев данных изображений и применимого законодательства.
                  </p>
                  <h3>
                    6. Использование Сайта
                  </h3>
                  <p>
                    6.1. Сайт может быть использован только Пользователями на территории Республики Казахстан и
                    только и исключительно в объёме Разрешённого Использования.
                  </p>
                  <p>
                    6.2. При использовании Сайта в соответствии с Разрешённым Использованием, Вам во всяком случае
                    необходимо сохранять указания на авторскую принадлежность Информации.
                  </p>
                  <p>
                  <div class="red-text">6.3. Запрещаются:</div>
                  а. Любое коммерческое и некоммерческое использование Сайта, Интеллектуальной Собственности, в том
                  числе, Информации, кроме Разрешённого Использования;
                  <p>
                    b. Доступ к Сайту, Интеллектуальной Собственности, в том числе, Информации, лицам, не достигшим
                    18-летнего возраста;
                  </p>
                  <p>
                    c. Сбор и обработка персональных данных, размещённых на Сайте (помимо прямо предусмотренных
                    Сайтом случаев использования контактных данных для обратной связи);
                  </p>
                  <p>
                    d. Любые несанкционированные Компанией, преднамеренные и непреднамеренные действия в отношении
                    Сайта, аппаратно-программного комплекса и объектов информатизации Сайта, Интеллектуальной
                    Собственности и Информации.
                  </p>
                  <p>
                    6.4. Во избежание сомнений, являются запрещёнными и не допускаются, среди прочего:<br>
                    a. Цитирование Информации, использование (в том числе воспроизведение, распространение,
                    публикация) или приведение ссылок на какую-либо Информацию; перевод, переработка и иные действия
                    в отношении Информации и Интеллектуальной собственности без письменного разрешения Компании или
                    иного правообладателя;<br>
                    b. изменение, модификация, копирование, дублирование, блокирование, уничтожение, перемещение,
                    нарушение целостности и сохранности Сайта и Информации.
                  </p>
                  <p>
                    6.5. Отдельные Разделы или страницы Сайта могут иметь ограниченный доступ. Вам запрещено
                    посещать данные страницы и ознакамливаться с размещённой на них Информацией, если Вы не
                    отвечаете условиям доступа к данным Разделам (на данные страницы).
                  </p>
                  <p>
                    6.6. Компания не ознакомлялась со всеми интернет-ресурсами, связанными с Сайтом (включая
                    интернет-ресурсы, содержащие ссылки на Сайт, и интернет-ресурсы, на которые имеются ссылки на
                    Сайте), и не несёт ответственности за их содержимое. Вы посещаете какие-либо такие
                    интернет-ресурсы на свой страх и риск.
                  </p>
                  <h3>7. Условия обратной связи</h3>
                  <p>
                    7.1. Любое сообщение или материал, которые Вы передаёте Компании, посредством электронной почты,
                    или через Сайт или иным образом, включая любые данные, информацию, вопросы, комментарии,
                    предложения или что-либо аналогичное, представляют собой и будут рассматриваться не являющимися
                    конфиденциальными и не вытекающими из права собственности.
                  </p>
                  <p>
                    7.2. Все, что Вы передаёте или публикуете, может быть использовано Компанией, Группой компаний
                    Тева в любых целях, включая, помимо прочего, воспроизведение, раскрытие, передачу, издание,
                    распространение, предоставление, публичное сообщение, публичный показ, публичное исполнение,
                    перевод, переработку, изменение, копирование, трансляцию и публикацию. Более того, Компания и
                    Группа компаний Тева вправе использовать любые идеи, концепции, ноу-хау и технологии,
                    содержащиеся в любом сообщении, направленном Вами Компании, для какой бы то ни было цели,
                    включая, помимо прочего, разработку, изготовление, маркетинг и реализацию продукции при помощи
                    таких идей, концепций, ноу-хау и технологий.
                  </p>
                  <h3>
                    8. Исключения и ограничение ответственности
                  </h3>
                  <p>
                    8.1. Вы используете и просматриваете Сайт на свой страх и риск. Компания по мере возможности
                    будет прикладывать разумные усилия, чтобы скорректировать какие-либо ошибки или упущения, о
                    которых нам станет известно. Тем не менее, мы не гарантируем бесперебойную работу Сайта в полном
                    объёме, а также не гарантируем, что информация, представленная на Сайте или посредством Сайта,
                    не будет содержать каких-либо ошибок или упущений.
                  </p>
                  <p>
                    8.2. Возможность доступа к Сайту и использования его содержимого может быть временно ограничена
                    без предварительного уведомления в случае системных сбоев, необходимости проведения технического
                    обслуживания или ремонта, либо в силу независящих от Компании причин, а также по любому
                    усмотрению Компании без объяснения причин.
                  </p>
                  <p>
                    8.3. Хотя Компания вправе время от времени осуществлять мониторинг и просматривать обсуждения,
                    чаты, посты, пересылки, доски объявлений и тому подобное на Сайте (при их наличии), Компания не
                    несёт обязательства осуществлять это, и не несёт ответственности или обязательств, возникающих
                    из содержания любого такого Раздела Сайта, либо за ошибки, клевету, обвинения, оскорбления,
                    упущения, ложь, рекламные материалы, непристойности, порнографию, сквернословие, угрозы,
                    раскрытие конфиденциальной информации или неточности, содержащиеся в какой-либо информации в
                    таких Разделах Сайта, размещёнными Вами или любыми иными лицами.
                  </p>
                  <p>
                    Вам запрещается публиковать на Сайте или пересылать Компании незаконные, рекламные, угрожающие,
                    клеветнические, порочащие, непристойные, предосудительные, подстрекательские, порнографические
                    или богохульные материалы, либо какие-нибудь материалы, которые могут представлять собой или
                    спровоцировать поведение, которое будет рассматриваться как уголовное или административное
                    правонарушение, привести к гражданско-правовой ответственности, или иным нарушениям
                    законодательства.
                  </p>
                  <p>Компания будет в полной мере сотрудничать с любыми правоохранительными органами и следовать
                    требованиям суда или государственного органа, согласно которым Компания должна раскрыть личность
                    какого-либо лица, публикующего любую такую информацию или материалы.</p>
                  <p>Компания оставляет за собой право удалять и не публиковать любые Ваши комментарии и сообщения на
                    Сайте.</p>
                  <p>8.4. Вам не следует расценивать что-либо на данном Сайте в качестве продвижения или рекламы
                    какой-либо продукции, или в целях использования какой-либо продукции, запрещённой
                    законодательством страны Вашего проживания.</p>
                  <p>8.5. Сайт не содержит никакие предложения (оферты) о заключении каких-либо договоров или
                    совершении сделок в отношении продукции, о которой имеется информация на Сайте. Любая Информация
                    о какой-либо продукции не означает предложение или обещание Компании о продаже или иной передаче
                    данной продукции.</p>
                  <p>
                    8.6. Сайт не предназначен для предоставления и не содержит никаких консультаций инвестиционного,
                    медицинского характера, или иных консультаций в сфере здравоохранения. Компания не оказывает
                    никакие услуги и не предоставляет посредством Сайта медицинскую помощь. Во избежание сомнений,
                    никакая Информация не может быть рассмотрена для цели диагностики или в качестве консультации по
                    вопросам здоровья или иным медицинским вопросам, а также не может быть использована в качестве
                    основания для назначения или применения каких-либо лекарственных средств или методов лечения.
                  </p>
                  <p>
                    8.7. Ничто на данном Сайте не представляет собой приглашения или предложения осуществить
                    инвестиции или заняться какими-либо ценными бумагами.
                  </p>
                  <p>
                    8.8. Ни Компания, ни Группа компаний Тева, ни какая-либо другая сторона, вовлечённая в создание,
                    изготовление, хостинг или предоставление Сайта, не имеет никаких обязанностей и не даёт никаких
                    обещаний перед Пользователем в связи с Сайтом и Информацией и не несёт ответственности за
                    какие-либо прямые, побочные, случайные, косвенные, штрафные и иные убытки, ущерб, упущенную
                    выгоду возникающие вследствие Вашего доступа или использования Сайта или Информации.
                  </p>
                  <p>
                    Не ограничивая общий смысл вышесказанного, всё на Сайте предоставляется Вам "В ТОМ СОСТОЯНИИ, В
                    КОТОРОМ НАХОДИТСЯ", БЕЗ КАКИХ-ЛИБО ГАРАНТИЙ И ЗАВЕРЕНИЙ, КАК В ПРЯМОМ, ТАК И В КОСВЕННОМ
                    ВЫРАЖЕНИИ, ВКЛЮЧАЯ, ПОМИМО ПРОЧЕГО, ПОДРАЗУМЕВАЕМЫЕ ГАРАНТИИ ТОВАРНОГО СОСТОЯНИЯ И ПРИГОДНОСТИ
                    ДЛЯ ИСПОЛЬЗОВАНИЯ ПО НАЗНАЧЕНИЮ ИЛИ ОТСУТСТВИЯ НАРУШЕНИЯ АВТОРСКИХ ПРАВ.
                  </p>
                  <p>
                    Без ущерба вышесказанному, инструкции по медицинскому применению лекарственных средств
                    публикуются в точном соответствии с текстом, утверждённым уполномоченным органом.
                  </p>
                  <p>
                    8.9. Компания не принимает на себя и не несёт ответственности за любой ущерб или вирусы, которые
                    могут заразить Ваше компьютерное оборудование или иное имущество вследствие Вашего доступа,
                    использования, в том числе, просмотра Сайта, а также загрузки каких-либо материалов, данных,
                    текстов, изображений, видео или аудио файлов или иной Информации с Сайта.
                  </p>
                  <h3>
                    9. Персональные данные
                  </h3>
                  <p>
                    9.1. Настоящим все Пользователи уведомляются о том, что Компания, Группа компаний Тева или
                    провайдеры различных услуг могут осуществлять сбор данных (в той мере, насколько позволяют
                    используемые Пользователями настройки и аппаратно-программный комплекс) о применяемых
                    Пользователями технических и программных средствах для доступа и использования Сайта, IP адресах
                    и об использовании Сайта. Такой сбор данных может осуществляться обычными способами,
                    применяемыми в сети Интернет (например, посредством Интернет-браузеров, файлов cookie, Flash
                    cookie и других интернет-технологий).
                  </p>
                  <p>
                    Собираемые таким образом данные: хранятся до минования надобности; предназначены для статистики
                    посещения Сайта, улучшения Сайта, маркетинговых программ, информационных целей, анализа данных,
                    защиты законных прав и интересов, а также для иной деятельности Группы компаний Тева; могут
                    обрабатываться всеми незапрещёнными применимым законодательством способами, в том числе,
                    раскрываться и передаваться иным лицам, включая трансграничную передачу, для вышеуказанных
                    целей.
                  </p>
                  <p>
                    Действия Пользователя по доступу и использованию Сайта означают его согласие на сбор и обработку
                    данных как указано выше в настоящем пункте Условий.
                  </p>
                  <p>
                    9.2. Вы вправе сами предоставить свои персональные данные Компании, например, посредством
                    подписки на новости или направления сообщения. Ваши действия по предоставлению Компании
                    персональных данных означают Ваше согласие на сбор и обработку Ваших персональных данных
                    (включая накопление, хранение, изменение, дополнение, использование, распространение,
                    трансграничную передачу, обезличивание, блокирование, уничтожение и иные действия с
                    персональными данными) для целей, связанных с таким предоставлением, а также для внутренних
                    учётных целей, контактов с Вами и иного использования в интересах Компании, Группы компаний Тева
                    и иных взаимосвязанных с ними лиц до минования надобности в соответствующих персональных данных.
                  </p>
                  <p>
                    При этом Ваше согласие распространяется на Компанию и Группу компаний Тева, а также иных лиц,
                    которым указанные данные могут быть переданы.
                  </p>
                  <p>9.3. Компания не ожидает, что Вы будете предоставлять ей персональные данные каких-либо третьих
                    лиц. Вы не вправе предоставлять Компании такие данные в отсутствие согласия субъекта
                    персональных данных. Предоставление Вами таких данных будет означать, под Вашу персональную
                    ответственность, наличие согласия субъекта персональных данных на сбор и обработку его
                    персональных данных Компанией, Группой компаний Тева и иными взаимосвязанными с ними лицами на
                    условиях, аналогичных указанным в предыдущем пункте Условий, включая, среди прочего, согласие на
                    трансграничную передачу.</p>
                  <p>
                    В случае отсутствия указанного выше согласия субъекта персональных данных Вы можете быть
                    привлечены к ответственности по возмещению убытков, возникших вследствие использования кем-либо
                    персональных данных без согласия субъекта персональных данных. Компания также будет ожидать, что
                    Вы самостоятельно и за свой счёт урегулируете все возможные претензии и требования.
                  </p>
                  <h3>
                    10. Общие положения
                  </h3>
                  <p>
                    10.1. Если какое-либо из настоящих Условий станет незаконным, недействительным или иным образом
                    неисполнимым в силу закона, в той степени и в пределах юрисдикции, в которой такое условие
                    является незаконным, недействительным или неисполнимым, остальные Условия остаются в силе и
                    сохраняют своё полное юридическое действие, а также продолжают оставаться обязательными для
                    исполнения и исполнимыми.
                  </p>
                  <p>
                    10.2. Настоящие Условия регулируются и толкуются в соответствии с законодательством Республики
                    Казахстан. Споры, возникающие в связи с настоящими Условиями, подпадают под исключительную
                    юрисдикцию судов Республики Казахстан.
                  </p>
                  <p>
                    10.3. В случае нарушения Условий Компания вправе потребовать возмещения убытков, выплаты
                    компенсаций, а также предпринять иные действия по защите нарушенных прав и привлечению виновных
                    лиц к ответственности в соответствии с применимым правом.
                  </p>
                  <p>Если у Вас появятся какие-либо вопросы в отношении настоящих Условий, пожалуйста, свяжитесь с
                    нами.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: 'TermsOfUse',
  title: 'Условия доступа к интернет-ресурсуи условия пользования интернет-ресурсом'
}
</script>
